import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

export default function Interests() {
  return (
    <>
      <h1 className='interests'>Interests</h1>
      <div className='filler'>
        <p>I love technology, drawing and create things.</p>
      </div>
      <Footer />
    </>
  );
}